import { InputText } from "primereact/inputtext"
import { classNames } from "primereact/utils"
import { Controller } from "react-hook-form"

interface IInput {
    label?: string,
    name: string,
    type?: string,
    control: any,
    error?: string,
    maxLength?: number,
    required?: boolean,
    disabled?: boolean,
    placeholder?: string,
    column?: number,
    onBlur?: () => void,
    info?: string
}

export const JVInput = (props: IInput) => {
    const className = props.column ? `field col-12 md:col-${12 / props.column}` : "field col-12 md:col-6";
    return (
        <div className={className}>
            {props.label && <label htmlFor={props.name}>{props.label}{props.required && <span style={{ color: 'red' }}>*</span>}</label>}
            <Controller name={props.name} control={props.control} render={({ field, fieldState }) => (
                <InputText {...field} maxLength={props.maxLength} onBlur={props.onBlur}
                    disabled={props.disabled}
                    placeholder={props.placeholder} type={props.type ? props.type : "text"}
                    min={props.type === "number" ? 0 : undefined}
                    step={props.type === "number" ? "any" : undefined}
                    onKeyDown={(e) => {
                        if (props.type === "number" && (e.key === "-" || e.key === "e" || e.key === "E")) {
                            e.preventDefault();
                        }
                    }}
                    className={classNames({ 'p-invalid': fieldState.invalid })} />
            )} />
            <small className="p-error" >{props.error}</small>
            {props.info && <small className="p-info" >{props.info}</small>}
        </div>
    );
}